import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {SimulationSession} from '../data/SimulationSession';
import {SimulationSessionProvider} from '../data/SimulationSessionProvider';
import {Router} from '@angular/router';
import {NewSessionDialogComponent} from '../new-session-dialog/new-session-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {EmailDialogComponent} from '../email-dialog/email-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {SimulationSessionResult} from '../data/SimulationSessionResult';
import {RestApiService} from '../services/rest-api.service';
import {AristoDialogComponent} from '../aristo-dialog/aristo-dialog.component';
import { ConnectionService } from 'ng-connection-service';

@Component({
  selector: 'app-results-overview',
  templateUrl: './results-overview.component.html',
  styleUrls: ['./results-overview.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultsOverviewComponent implements OnInit {

  simulationSession!: SimulationSession;
  electricityPrice = 25;
  isConnected = true;

  formatLabel(value: number) {
    return value / 100 + '€';
  }

  constructor(private restApi: RestApiService,
              private translate: TranslateService,
              private simulationSessionProvider: SimulationSessionProvider,
              private router: Router,
              public dialog: MatDialog,
              private connectionService: ConnectionService) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
    });
  }

  ngOnInit(): void {

    this.simulationSession = this.simulationSessionProvider.getSimulationSession();
    if (this.simulationSession.electricityPrice && this.simulationSession.electricityPrice > 0) {
      this.electricityPrice = this.simulationSession.electricityPrice * 100;
    }
    else {
      this.simulationSession.electricityPrice = this.electricityPrice / 100;
    }
    this.calculateResults();

  }

  calculateResults() {

    this.simulationSession.electricityPrice = this.electricityPrice / 100;

    let totalTradPrice = this.simulationSession.priceTradWithoutInstallation;
    let totalPriceAriston = this.simulationSession.priceAristonWithoutInstallation - this.simulationSession.bonus;
    if (this.simulationSession.calculateWithInstallation) {
      totalTradPrice = this.simulationSession.priceTradWithInstallation;
      totalPriceAriston = this.simulationSession.priceAristonWithInstallation;
    }

    const differencePrice = totalPriceAriston - totalTradPrice;

    const differenceConsumption = Number(this.simulationSession.model.consoTrad)
      - Number(this.simulationSession.model.conso);
    const differenceConsumptionEuro = differenceConsumption * this.simulationSession.electricityPrice;

    const amortizationTime = differencePrice / differenceConsumptionEuro;
    const amortizationYears = Math.floor(amortizationTime);
    let amortizationMonths = amortizationTime - amortizationYears;
    amortizationMonths = amortizationMonths / 10 * 12;
    amortizationMonths = Math.round(amortizationMonths * 10);

    this.simulationSession.amortizationDifferenceY = '' + amortizationYears;
    this.simulationSession.amortizationDifferenceM = '' + amortizationMonths;
    this.simulationSession.returnOnInvestments = (differenceConsumptionEuro / totalPriceAriston * 100)
      .toFixed(2);
    this.simulationSession.yearlySavings = (differencePrice / amortizationTime).toFixed(2);

  }

  public goHome() {
    const dialogRef = this.dialog.open(NewSessionDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === true){
        this.simulationSessionProvider.resetSimulationSession();
        this.router.navigate(['/home']);
      }
    });
  }

  public sendEmailWithResults(){
    const dialogRef = this.dialog.open(EmailDialogComponent);

    let years = 'an(s)';
    let months = 'mois';

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === true){
        this.translate.get('RESULTS_OVERVIEW.YEARS', {value: 'an(s)'})
          .subscribe((res: string) => {
          console.log(res);
          years = res;
        });

        this.translate.get('RESULTS_OVERVIEW.MONTHS', {value: 'an(s)'})
          .subscribe((res: string) => {
          console.log(res);
          months = res;
        });

        const simulationSessionResult: SimulationSessionResult = {
          email: dialogRef.componentInstance.emailAddress,
          priceBoilerTrad: this.simulationSession.priceTradWithoutInstallation.toFixed(2) + '€',
          aristonBoilerModel: this.simulationSession.model.name + ' ' + this.simulationSession.model.litrage + 'L',
          priceBoilerAriston: this.simulationSession.priceAristonWithoutInstallation.toFixed(2) + '€',
          priceWithInstallationTrad: this.simulationSession.priceTradWithInstallation.toFixed(2) + '€',
          priceWithInstallationAriston: this.simulationSession.priceAristonWithInstallation.toFixed(2) + '€',
          tva: this.simulationSession.tva + '%',
          prime: this.simulationSession.bonus + '€',
          priceElectricity: this.simulationSession.electricityPrice + '€',
          amortization: this.simulationSession.amortizationDifferenceY
            + years + ' ' + this.simulationSession.amortizationDifferenceM + months,
          returnOnInvestments: this.simulationSession.returnOnInvestments + '%',
          savings: this.simulationSession.yearlySavings + '€'
        };

        this.restApi.sendEmail(JSON.stringify(simulationSessionResult)).subscribe(
          data => {
            this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.SEND_RESULT.SUCCESS'}});
          },
          error => {
            this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.SEND_RESULT.FAILURE'}});
          }
        );
      }
    });
  }

}
